import { COLORS } from '../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme =>
  // take mobile-first approach to do the styling

  // const minSm = theme.breakpoints.up('sm');
  // const minMd = theme.breakpoints.up('md');
  // const minLg = theme.breakpoints.up('lg');
  // const minXl = theme.breakpoints.up('xl');

  ({
    actionsToggleButton: {
      padding: 0,
    },
    popper: {
      zIndex: 9,
      '&[x-placement*="bottom"] $arrow': {
        top: 0,
        right: 2,
        width: '3em',
        height: '1em',
        '&::before': {
          marginTop: -7,
          borderWidth: '0 1em 1em 1em',
          borderColor: `transparent transparent ${COLORS.GREY} transparent`,
        },
        '&::after': {
          marginTop: -6,
          borderWidth: '0 1em 1em 1em',
          borderColor: `transparent transparent ${COLORS.WHITE} transparent`,
        },
      },
      '&[x-placement*="top"] $arrow': {
        bottom: 0,
        right: 2,
        width: '3em',
        height: '1em',
        '&::before': {
          marginTop: 8,
          borderWidth: '1em 1em 0 1em',
          borderColor: `${COLORS.GREY} transparent transparent transparent`,
        },
        '&::after': {
          marginTop: -9,
          borderWidth: '1em 1em 0 1em',
          borderColor: `${COLORS.WHITE} transparent transparent transparent`,
        },
      },
    },
    arrow: {
      zIndex: 10,
      position: 'absolute',
      fontSize: 7,
      width: '3em',
      height: '3em',
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
      },
      '&::after': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: 0,
        height: 0,
        borderStyle: 'solid',
      },
    },
    cardHeaderRoot: {
      paddingTop: 15,
      paddingBottom: 15,
      paddingRight: 15,
      borderBottom: `1px solid ${COLORS.GREY_LIGHTER}`,
    },
    cardHeaderTitle: {
      fontSize: '0.875rem',
      color: COLORS.GREY_DARK,
      marginRight: 10,
    },
    cardHeaderAction: {
      marginTop: 0,
      marginRight: 0,
    },
    closeActionsPopoverButton: {
      color: COLORS.GREEN,
      padding: 0,
    },
    cardContentRoot: {
      padding: 0,
      '&:last-child': {
        paddingBottom: 0,
      },
    },
    menuItem: {
      fontSize: '1rem',
      color: COLORS.GREEN,
    },
  });
export default styles;
